import { getTenant } from 'services/tenants';

export const shouldApplyImageRestrictions = () => {
  const tenant = getTenant();
  return tenant.project === 'themis';
};
